import useReport from '@/components/reports/useReport';
import { uiStateProxy } from '@/state/ui-state';
import { useTrackedSnapshot } from 'valtio-select';

export default function useCurrentReport() {
  const reportId = useTrackedSnapshot(
    uiStateProxy,
    (state) => state.reportIdForDetails
  );
  const { invalidate: invalidateReport } = useReport(reportId);

  return {
    reportId,
    invalidate: invalidateReport,
  };
}
